import { getInitialState } from './state';

const mutations = {
  SET_RESET_QUESTIONNAIRE(state) {
    Object.assign(state, getInitialState());
  },

  SET_QUESTIONNAIRE(state, questionnaire) {
    state.received = questionnaire;
  },

  SET_TOSEND(state, questions) {
    state.toSend.push(questions);
  },

  SET_MEDICATIONS(state, medications) {
    state.medications = medications;
  },
  SET_CLEAR_MEDICATIONS(state) {
    state.medications = '';
  },
  SET_CLEAR_QUESTIONNAIRE(state) {
    const initialState = {
      received: [],
      toSend: [],
      medications: ''
    };

    Object.assign(state, initialState);
  }
};

export default mutations;
